import React from 'react'
import {TableCell, TableRow, Tooltip, withStyles} from '@material-ui/core';
import styles from '../styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';


function InsertHeader(props) {

  const {className, t, canExpand} = props;

  return (
    <TableRow className={className}>
      <TableCell
        colSpan={2}
        style={canExpand ? {} : {fontSize: 'inherit'}}
      >{t('productDescription')}</TableCell>
      <TableCell style={canExpand ? {} : {fontSize: 'inherit'}}>{t('productAmount')}</TableCell>
      <Tooltip title={t('productPerUnit')}>
        <TableCell style={canExpand ? {} : {fontSize: 'inherit'}}>{t('productWeight')}</TableCell>
      </Tooltip>
    </TableRow>
  );
}


InsertHeader.propTypes = {
  canExpand: PropTypes.bool,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}
;

export default compose(withStyles(styles), withTranslation())(InsertHeader);
